import React from 'react';
import { buildRegionOptions } from '../../../utils/locationOptions';
import BaseSelect from './BaseSelect';

// 선택된 국가에 대응하는 하위 지역을 표기하는 셀렉트
export default function RegionSelect({
  country, // ISO code expected (e.g., 'KR')
  value,
  onChange,
  className = '',
  defaultOptionLabel = '지역',
  disabled: disabledProp,
  ...props
}) {
  const opts = buildRegionOptions(country, {
    countryValueType: 'short',
    valueType: 'short',
  }).map((o) => ({ label: o.label, value: o.value, key: o.code || o.label }));

  const disabled = disabledProp ?? !country;

  return (
    <BaseSelect
      options={opts}
      value={value}
      onChange={onChange}
      placeholder={defaultOptionLabel}
      className={className}
      disabled={disabled}
      ariaLabel="지역 선택"
      variant="region"
      {...props}
    />
  );
}
